class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');

    // Desktop: open dropdowns on hover (e.g. Build Your Vibe → 100ml / 50ml / 30ml)
    if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      this.addEventListener('mouseenter', this.onHoverOpen.bind(this));
      this.addEventListener('mouseleave', this.onHoverClose.bind(this));
      // a click right after hover-open shouldn't snap the menu shut
      this.mainDetailsToggle.querySelector('summary').addEventListener('click', (event) => {
        // a link inside the label (Perfume Kit → /pages/perfume-kit) must still navigate
        if (event.target.closest('a')) return;
        if (this.hoverOpened) {
          event.preventDefault();
          this.hoverOpened = false;
        }
      });
    }
  }

  onHoverOpen() {
    clearTimeout(this.hoverCloseTimer);
    if (this.mainDetailsToggle.open) return;
    document.querySelectorAll('header-menu details[open]').forEach((details) => {
      if (details !== this.mainDetailsToggle) details.closest('header-menu').close();
    });
    this.mainDetailsToggle.setAttribute('open', '');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
    this.hoverOpened = true;
  }

  onHoverClose() {
    // short delay so the pointer can cross the gap between the label and the dropdown
    this.hoverCloseTimer = setTimeout(() => {
      this.hoverOpened = false;
      this.close();
    }, 200);
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
